import React from 'react';
import { motion } from 'framer-motion';
import { Book, CheckCircle2 } from 'lucide-react';
export function SystemOverview() {
  const tomos = [{
    icon: '🟢',
    title: 'Tomo 1 — NEURODESARROLLO & TEA',
    desc: 'Funciones ejecutivas · Anticipación y agendas visuales · Regulación conductual · Categorización · Atención sostenida · Comunicación aumentativa · Planificador de sesiones. Niños y adolescentes'
  }, {
    icon: '🟡',
    title: 'Tomo 2 — GERONTOLOGÍA & COGNICIÓN',
    desc: 'Estimulación cognitiva · Reminiscencia · Memoria y atención · Orientación temporoespacial · Cálculo cotidiano · Gnosias y praxias · Acompañamiento emocional · Planificador mensual. Adultos mayores'
  }, {
    icon: '🟠',
    title: 'Tomo 3 — INTEGRACIÓN ESCOLAR',
    desc: 'Apoyo en aula · Adaptaciones curriculares · Lectoescritura adaptada · Autorregulación · Recreos dirigidos · Articulación con el EOE · Sistema de señales · Planificador de jornada. Niños y adolescentes'
  }, {
    icon: '🔴',
    title: 'Tomo 4 — SALUD MENTAL & PSICOSIS',
    desc: 'Estructuración psíquica · Lazo social · Expresión artística · Guiones sociales · Salidas comunitarias · Vínculo terapéutico · Protocolo de riesgo suicida · Planificador mensual. Adultos'
  }, {
    icon: '🟣',
    title: 'Tomo 5 — DISCAPACIDAD MOTRIZ',
    desc: 'Juegos adaptados · Autonomía personal · Motricidad fina · AVD · Estimulación sensorial · Accesibilidad y derechos · CUD · Planificador de sesiones. Todas las edades'
  }, {
    icon: '⭐',
    title: 'Tomo 6 — GESTIÓN CLÍNICA (BITÁCORA)',
    desc: 'Documentación profesional · Informes mensuales · Planillas de asistencia · Notas de evolución · Plan de trabajo · Contrato de servicios · Facturación · Obras sociales · Checklist de cierre mensual'
  }];
  const includes = ['Planificación mensual lista para usar', '20-30 actividades clínicas con objetivo y registro', 'Protocolos de intervención con fichas de seguimiento', 'Plantillas de informe listas para completar', 'Materiales imprimibles para usar en sesión', '100% adaptado al AT argentino 2026'];
  return <section className="py-16 px-4 pt-[15px] pb-[15px]" data-id="element-254">
      <div className="max-w-6xl mx-auto" data-id="element-255">
        <div className="text-center mb-12" data-id="element-256">
          <div className="inline-flex items-center space-x-2 bg-brand/10 text-brand px-4 py-2 rounded-full mb-6 font-bold" data-id="element-257">
            <Book className="w-5 h-5" data-id="element-258" />
            <span data-id="element-259">EL SISTEMA</span>
          </div>
          <h2 className="md:text-5xl font-black mb-4 text-[28px]" data-id="element-260">
            ULTRAPACK TERAPÉUTICO PRO™
          </h2>
          <p className="text-brand font-bold mt-2" data-id="element-261">
            +480 páginas · 150+ actividades clínicas listas · Registros ·
            Informes · Protocolos · Contratos · Gestión · Facturación ·
            Pictogramas · Crisis.
          </p>
        </div>

        <h3 className="text-2xl font-bold mb-6 text-center mt-[-30px]" data-id="element-262">
          📚 LOS 6 TOMOS — Para ATs de todas las áreas clínicas
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-12" data-id="element-263">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-dark-card border border-dark-border rounded-2xl p-4 hover:border-brand/50 transition-colors" data-id="element-264">
              <div className="text-2xl mb-3" data-id="element-265">{tomo.icon}</div>
              <h4 className="text-lg font-bold mb-2" data-id="element-266">{tomo.title}</h4>
              <p className="text-gray-400 text-sm" data-id="element-267">{tomo.desc}</p>
            </motion.div>)}
        </div>

        <div className="bg-dark-card border border-dark-border rounded-2xl p-8 max-w-3xl mx-auto mt-[-25px] pt-[15px] pb-[15px] pl-[15px] pr-[15px] space-x-[12px] space-y-[16px]" data-id="element-268">
          <h4 className="text-xl font-bold mb-6 text-center" data-id="element-269">
            Cada tomo incluye:
          </h4>
          <div className="space-y-4" data-id="element-270">
            {includes.map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-center space-x-3" data-id="element-271">
                <CheckCircle2 className="w-6 h-6 text-brand flex-shrink-0" data-id="element-272" />
                <span className="text-gray-300 text-[16px]" data-id="element-273">{item}</span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}